export default __webpack_public_path__ + "atomic/_patterns/02-molecules/attributes-list/_attributes-list.twig";